var map = {
	"./blocks.png": 3022,
	"./books-blue.png": 3023,
	"./books.png": 3024,
	"./cancel-blue.png": 3025,
	"./cancel.png": 3026,
	"./clock-blue.png": 3027,
	"./clock.png": 3028,
	"./confetti.png": 3029,
	"./flag-blue.png": 3030,
	"./flag.png": 3031,
	"./gauge-blue.png": 3032,
	"./gauge.png": 3033,
	"./gear.png": 3034,
	"./lightbulb-blue.png": 3035,
	"./lightbulb.png": 3036,
	"./magnifier-white.png": 3037,
	"./open-book-white.png": 3038,
	"./pencil.png": 3039,
	"./question-and-answer.png": 3040,
	"./rising-blue.png": 3041,
	"./rising.png": 3042,
	"./settings-gears-white.png": 3043,
	"./slow.png": 3044,
	"./star.png": 3045,
	"./target.png": 3046,
	"./writing-white.png": 3047
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\.png$
// module id = 205
// module chunks = 0